import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "pair-toggle" }
const _hoisted_2 = {
  key: 0,
  class: "ontos-field-label"
}
const _hoisted_3 = { class: "pair-toggle-hint text-body-2 text-medium-emphasis" }
const _hoisted_4 = {
  key: 1,
  class: "pair-toggle-more"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_v_btn_toggle, {
      "model-value": _ctx.modelValue,
      mandatory: "",
      divided: "",
      density: "comfortable",
      variant: "outlined",
      disabled: _ctx.disabled,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, { value: false }, {
          default: _withCtx(() => [
            (_ctx.off.icon)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  start: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.off.icon), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.off.label), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          value: true,
          color: _ctx.on.color
        }, {
          default: _withCtx(() => [
            (_ctx.on.icon)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  start: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.on.icon), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.on.label), 1)
          ]),
          _: 1
        }, 8, ["color"])
      ]),
      _: 1
    }, 8, ["model-value", "disabled"]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.disabled && _ctx.disabledReason)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_icon, {
              size: "small",
              start: ""
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-lock", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(_toDisplayString(_ctx.disabledReason), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_ctx.modelValue ? _ctx.on.hint : _ctx.off.hint), 1)
          ], 64))
    ]),
    (_ctx.modelValue && _ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}